<h2 mat-dialog-title>Debug — {{ data.title }}</h2>

<div mat-dialog-content>
  <pre class="debug-json">{{ data.model | json }}</pre>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()">Close</button>
</div>
